import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/$slug/")({
  staticData: { title: "Dashboard" },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/dashboard/page.tsx"),
    "DashboardPage",
  ),
})
